var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveCursorBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 59,
    stroke: "#303030",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9338 67V60.682C41.9338 58.72 41.8978 57.298 41.8258 56.812L46.0198 67H47.2618L51.4558 56.758C51.3838 57.64 51.3478 58.63 51.3478 60.88V67H52.6258V54.112H51.3298L46.6318 65.47L41.9338 54.112H40.6558V67H41.9338ZM54.8735 62.644C54.8735 65.29 56.7455 67.216 59.3015 67.216C61.8575 67.216 63.7295 65.29 63.7295 62.644C63.7295 59.98 61.8575 58.054 59.3015 58.054C56.7455 58.054 54.8735 59.98 54.8735 62.644ZM56.1335 62.626C56.1335 60.61 57.4295 59.17 59.3015 59.17C61.1555 59.17 62.4695 60.61 62.4695 62.626C62.4695 64.678 61.1555 66.1 59.3015 66.1C57.4295 66.1 56.1335 64.678 56.1335 62.626ZM67.7592 67H69.0012L72.6192 58.288H71.3412L69.0552 63.904C68.8032 64.534 68.5692 65.11 68.4072 65.704C68.2452 65.128 68.0112 64.534 67.7772 63.904L65.5272 58.288H64.1952L67.7592 67ZM77.3504 67.216C79.4024 67.216 80.7524 66.226 81.2204 64.39H80.0324C79.7084 65.542 78.7904 66.154 77.3684 66.154C75.4964 66.154 74.3804 64.93 74.2904 62.806H81.2204V62.194C81.2204 59.728 79.6184 58.054 77.2604 58.054C74.7764 58.054 73.0844 59.926 73.0844 62.644C73.0844 65.38 74.7944 67.216 77.3504 67.216ZM77.2604 59.116C78.8984 59.116 79.9784 60.232 79.9784 61.906H74.3264C74.5424 60.196 75.6224 59.116 77.2604 59.116Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveCursorBlack);
export default __webpack_public_path__ + "static/media/move_cursor_black.1ea051a5ab5283d20c7507e3ce6bfcb8.svg";
export { ForwardRef as ReactComponent };